(function() {
  'use strict';

  // Initialize dropdown functionality for all group dropdowns
  function initGroupDropdowns(groupNum) {
    const selector = '[data-group' + groupNum + '-dropdown]';
    const headerSelector = '[data-group' + groupNum + '-header]';
    const optionsClass = '.group' + groupNum + '-dropdown__options';
    const titleClass = '.group' + groupNum + '-dropdown__title';
    const optionClass = '.group' + groupNum + '-dropdown__option';
    const imagesSelector = '[data-group' + groupNum + '-images]';
    const collectionClass = '.group' + groupNum + '-collection-images';
    
    document.querySelectorAll(selector).forEach(function(dropdown) {
      const blockId = dropdown.getAttribute('data-group' + groupNum + '-dropdown');
      const header = dropdown.querySelector('[data-group' + groupNum + '-header="' + blockId + '"]');
      const options = dropdown.querySelector(optionsClass);
      const title = dropdown.querySelector(titleClass);
      // Try to find imagesContainer within the same wrapper first, then fallback to document-wide search
      const wrapper = dropdown.closest('.pure-mega-menu__wrapper');
      const imagesContainer = wrapper 
        ? wrapper.querySelector('[data-group' + groupNum + '-images="' + blockId + '"]')
        : document.querySelector('[data-group' + groupNum + '-images="' + blockId + '"]');
      
      // Only require header, options, and title - imagesContainer is optional
      if (!header || !options || !title) return;

      // Toggle dropdown on header click - use capture phase to run before other handlers
      header.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        header.classList.toggle('active');
      }, true);
      
      // Prevent clicks inside dropdown from bubbling to summary (but allow dropdown to work)
      // Only handle this for the options container, not individual options
      const optionsContainer = dropdown.querySelector(optionsClass);
      if (optionsContainer) {
        optionsContainer.addEventListener('click', function(e) {
          // Don't stop propagation here - let option handlers work
          // Just keep mega menu open
          const megaMenuDetails = dropdown.closest('details.mega-menu');
          if (megaMenuDetails) {
            megaMenuDetails.setAttribute('open', '');
          }
        });
      }

      // Find the mega menu details element and HeaderMenu instance
      const megaMenuDetails = dropdown.closest('details.mega-menu');
      const megaMenuSummary = megaMenuDetails ? megaMenuDetails.querySelector('summary') : null;
      const headerMenuElement = megaMenuDetails ? megaMenuDetails.closest('header-menu') : null;
      
      // Flag to prevent closing when interacting with dropdown
      let preventClose = false;
      let keepOpenInterval = null;
      
      // Function to keep mega menu open
      function keepMegaMenuOpen() {
        if (megaMenuDetails && preventClose) {
          if (!megaMenuDetails.hasAttribute('open')) {
            megaMenuDetails.setAttribute('open', '');
          }
          if (megaMenuSummary) {
            megaMenuSummary.setAttribute('aria-expanded', 'true');
          }
        }
      }
      
      // Override the close method on HeaderMenu if it exists
      if (headerMenuElement && typeof headerMenuElement.close === 'function') {
        const originalClose = headerMenuElement.close.bind(headerMenuElement);
        headerMenuElement.close = function() {
          if (preventClose) {
            keepMegaMenuOpen();
            return; // Don't close if flag is set
          }
          originalClose();
        };
      }
      
      // Use MutationObserver to watch for changes to the open attribute
      if (megaMenuDetails) {
        const observer = new MutationObserver(function(mutations) {
          if (preventClose) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                if (!megaMenuDetails.hasAttribute('open')) {
                  // Re-open immediately if it was closed
                  setTimeout(function() {
                    megaMenuDetails.setAttribute('open', '');
                  }, 0);
                }
              }
            });
          }
        });
        
        observer.observe(megaMenuDetails, {
          attributes: true,
          attributeFilter: ['open']
        });
        
        // Also prevent toggle event from closing when preventClose is true
        megaMenuDetails.addEventListener('toggle', function(e) {
          if (preventClose && !megaMenuDetails.hasAttribute('open')) {
            // Re-open immediately
            setTimeout(function() {
              megaMenuDetails.setAttribute('open', '');
            }, 0);
          }
        });
      }
      
      // Handle option selection
      dropdown.querySelectorAll(optionClass).forEach(function(option) {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Set flag to prevent closing
          preventClose = true;
          
          const linkTitle = option.getAttribute('data-link-title');
          const linkHandle = option.getAttribute('data-link-handle');
          
          // Update header text
          if (title && linkTitle) {
            title.textContent = linkTitle;
          }
          
          // Close dropdown
          header.classList.remove('active');
          
          // Show corresponding collection images
          if (imagesContainer && linkHandle) {
            const allCollections = imagesContainer.querySelectorAll(collectionClass);
            const targetCollection = imagesContainer.querySelector('[data-collection-handle="' + linkHandle + '"]');
            
            // Hide all collections
            allCollections.forEach(function(collection) {
              collection.style.display = 'none';
            });
            
            // Show selected collection
            if (targetCollection) {
              targetCollection.style.display = 'block';
            } else if (allCollections.length > 0) {
              // Fallback: show first collection if target not found
              allCollections[0].style.display = 'block';
            }
          } else if (imagesContainer && !linkHandle) {
            // If no linkHandle but imagesContainer exists, show first collection
            const allCollections = imagesContainer.querySelectorAll(collectionClass);
            if (allCollections.length > 0) {
              allCollections.forEach(function(collection, index) {
                collection.style.display = index === 0 ? 'block' : 'none';
              });
            }
          }
          
          // Find menu drawer/header drawer to prevent it from closing on mobile
          const menuDrawer = dropdown.closest('menu-drawer, header-drawer');
          if (menuDrawer) {
            // Prevent drawer from closing
            const drawerDetails = menuDrawer.querySelector('details[open]');
            if (drawerDetails) {
              drawerDetails.setAttribute('open', '');
            }
          }
          
          // Ensure mega menu stays open
          if (megaMenuDetails) {
            // Immediately set open
            megaMenuDetails.setAttribute('open', '');
            if (megaMenuSummary) {
              megaMenuSummary.setAttribute('aria-expanded', 'true');
            }
            
            // Start interval to keep it open
            if (keepOpenInterval) {
              clearInterval(keepOpenInterval);
            }
            keepOpenInterval = setInterval(keepMegaMenuOpen, 10);
            
            // Keep focus within mega menu
            setTimeout(function() {
              if (header) {
                header.setAttribute('tabindex', '-1');
                header.focus();
                header.removeAttribute('tabindex');
              }
            }, 0);
            
            // Stop keeping open after a delay (longer to ensure it stays open)
            setTimeout(function() {
              if (keepOpenInterval) {
                clearInterval(keepOpenInterval);
                keepOpenInterval = null;
              }
              // Don't reset preventClose immediately - keep it for a bit longer
              setTimeout(function() {
                preventClose = false;
              }, 100);
            }, 300);
          }
        }, true); // Use capture phase to run before other handlers
      });
      
      // Also prevent summary clicks when clicking inside dropdown (but allow dropdown header to work)
      // Note: We don't prevent option clicks here - just keep menu open
      if (megaMenuSummary) {
        megaMenuSummary.addEventListener('click', function(e) {
          // Check if clicking on dropdown header, options, or options container
          const clickedDropdownHeader = e.target.closest('.group' + groupNum + '-dropdown__header');
          const clickedOption = e.target.closest(optionClass);
          const clickedOptionsContainer = e.target.closest(optionsClass);
          
          if (clickedDropdownHeader || clickedOption || clickedOptionsContainer) {
            // Don't prevent or stop - just keep menu open
            // The dropdown header's own click handler will handle the toggle
            // The option's own click handler will handle the selection
            if (megaMenuDetails) {
              megaMenuDetails.setAttribute('open', '');
            }
            // Allow the event to continue to the dropdown header handler
            return;
          }
        }, true);
      }
      
      // Prevent menu drawer from closing when clicking dropdown options (mobile)
      const menuDrawer = dropdown.closest('menu-drawer, header-drawer');
      if (menuDrawer) {
        // Override the closeMenuDrawer method if it exists
        if (typeof menuDrawer.closeMenuDrawer === 'function') {
          const originalCloseMenuDrawer = menuDrawer.closeMenuDrawer.bind(menuDrawer);
          menuDrawer.closeMenuDrawer = function(event, elementToFocus) {
            // Check if the event target is inside a dropdown
            if (event && event.target) {
              const clickedInDropdown = event.target.closest('.group' + groupNum + '-dropdown');
              if (clickedInDropdown) {
                // Don't close if clicking inside dropdown
                return;
              }
            }
            originalCloseMenuDrawer(event, elementToFocus);
          };
        }
        
        // Also prevent drawer from closing via details toggle
        const drawerDetails = menuDrawer.querySelector('details');
        if (drawerDetails) {
          drawerDetails.addEventListener('toggle', function(e) {
            // If preventClose is set and clicking inside dropdown, prevent closing
            if (preventClose) {
              const clickedInDropdown = e.target && e.target.closest('.group' + groupNum + '-dropdown');
              if (clickedInDropdown && !drawerDetails.hasAttribute('open')) {
                drawerDetails.setAttribute('open', '');
              }
            }
          });
        }
      }
      
      
      // Prevent focusout from closing mega menu when interacting with dropdown
      if (megaMenuDetails) {
        megaMenuDetails.addEventListener('focusout', function(e) {
          // If focus is moving to something inside the mega menu, don't close
          if (megaMenuDetails.contains(e.relatedTarget)) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }

      // Close dropdown when clicking outside (but not when clicking the header itself)
      document.addEventListener('click', function(e) {
        // Don't close if clicking on the dropdown header (it handles its own toggle)
        if (e.target.closest('.group' + groupNum + '-dropdown__header')) {
          return;
        }
        if (!dropdown.contains(e.target)) {
          header.classList.remove('active');
        }
      });
    });
  }

  // Initialize on DOM ready for all groups
  function initAllGroupDropdowns() {
    initGroupDropdowns(1);
    initGroupDropdowns(2);
    initGroupDropdowns(3);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGroupDropdowns);
  } else {
    initAllGroupDropdowns();
  }

  // Close mega menu when clicking on other menu items
  function initMenuCloseOnOtherClick() {
    document.addEventListener('click', function(e) {
      // Don't close if clicking inside an open mega menu content
      const clickedInsideMegaMenu = e.target.closest('.mega-menu__content');
      if (clickedInsideMegaMenu) return;

      // Check if clicking on a mainparent-listitem or its summary
      const clickedMenuItem = e.target.closest('.mainparent-listitem');
      const clickedSummary = e.target.closest('summary.header__menu-item');
      
      if (!clickedMenuItem && !clickedSummary) return;

      // Find all open mega menus
      const allMegaMenus = document.querySelectorAll('details.mega-menu[open]');
      
      if (allMegaMenus.length === 0) return;

      // Check if the clicked menu item contains a mega menu
      const clickedMegaMenu = clickedMenuItem ? clickedMenuItem.querySelector('details.mega-menu') : null;
      const clickedSummaryParent = clickedSummary ? clickedSummary.closest('details.mega-menu') : null;
      const targetMegaMenu = clickedMegaMenu || clickedSummaryParent;
      
      // Close all other mega menus (except the one being clicked, if any)
      allMegaMenus.forEach(function(megaMenu) {
        // Don't close if it's the one being clicked (let it toggle naturally)
        if (megaMenu !== targetMegaMenu) {
          megaMenu.removeAttribute('open');
          const summary = megaMenu.querySelector('summary');
          if (summary) {
            summary.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  }

  // Initialize menu close handler
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuCloseOnOtherClick);
  } else {
    initMenuCloseOnOtherClick();
  }
})();
